import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Paddle, PaddleEventData } from "@paddle/paddle-js";
import { Cart, addOns } from "@version2/domain-package";
import type { User } from "firebase/auth";
import { env } from "src/Consts/config";

interface PaddleState {
	paddle: Paddle | undefined;
	isInitialized: boolean;
}

const initialState: PaddleState = {
	paddle: undefined,
	isInitialized: false,
};

export const paddleSlice = createSlice({
	name: "paddle",
	initialState,
	reducers: {
		setPaddleEventCallback: (
			state,
			action: PayloadAction<(data: PaddleEventData) => void>
		) => {
			state.paddle?.Update({ eventCallback: action.payload });
		},
		clearPaddleEventCallback: (state) => {
			state.paddle?.Update({
				eventCallback: undefined,
			});
		},
		init: (state, action: PayloadAction<Paddle | undefined>) => {
			if (state.isInitialized) return;
			state.paddle = action.payload;
			state.isInitialized = true;
		},
		updateUser: (state, action: PayloadAction<{ id?: string }>) => {
			if (!state.paddle || !state.isInitialized) {
				console.error("Paddle is not initialized");
				return;
			}
			try {
				state.paddle?.Update({ pwCustomer: { id: action.payload.id } });
			} catch (e) {
				console.error(e);
			}
		},
		openCheckout: (
			state,
			action: PayloadAction<{ checkout: Cart | string; user: User; checkoutId?: string }>
		) => {
			if (!state.paddle || !state.isInitialized) {
				console.error("Paddle is not initialized");
				return;
			}
			const userEmail = action.payload.user.email;
			if (!userEmail) return;
			let items = undefined;
			let transactionId = undefined;
			if (action.payload.checkout instanceof Cart) {
				items = (action.payload.checkout as Cart).items.map((item) => {
					const plan = addOns(env.ENV).planFromInternalId(
						item._.internalPlanId
					);
					return {
						priceId: plan?._.externalId || "",
						quantity: item._.quantity,
					};
				});
			} else if (typeof action.payload.checkout === "string") {
				transactionId = action.payload.checkout;
			}
				try {
					// @ts-expect-error Paddle Checkout typing is incomplete for open settings payload.
					state.paddle?.Checkout.open({
					settings: {
						allowLogout: false,
						displayMode: "inline",
						theme: "light",
						locale: "en",
						frameTarget: "paddle-checkout",
						frameInitialHeight: 450,
						frameStyle:
							"width:100%; min-width:312px; background-color: transparent; border: none;",
					},
					customer: { email: userEmail },
					customData: {
						user_id: action.payload.user?.uid || "",
						checkout_id: action.payload.checkoutId || "none",
					},
					items,
					transactionId,
				});
			} catch (e) {
				console.error(e);
			}
		},
	},
});

export const {
	setPaddleEventCallback,
	clearPaddleEventCallback,
	openCheckout,
	updateUser,
} = paddleSlice.actions;

export default paddleSlice.reducer;
